import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { getActionsByPatientExam } from '../../common/services/next-gen/PatientTrackingService';
import PatientTrackingActionsList from './PatientTrackingActionsList';

/**
 * PatientTrackingResultModal Component
 *
 * Read-only modal that displays patient tracking actions linked to a specific result.
 * Fetches all actions for the exam and filters to those whose patientResultId matches.
 *
 * @component
 * @param {Object} props
 * @param {boolean} props.show - Whether the modal is visible
 * @param {Function} props.onHide - Callback to close the modal
 * @param {string} props.patientExamId - Patient exam ID used to fetch tracking actions
 * @param {string} props.patientResultId - Patient result ID used to filter actions
 */
const PatientTrackingResultModal = ({ show, onHide, patientExamId, patientResultId }) => {
    const [actions, setActions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!show || !patientExamId) return;

        setLoading(true);
        getActionsByPatientExam(patientExamId)
            .then(data => {
                const filtered = (data || []).filter(a => a.patientResultId === patientResultId);
                setActions(filtered);
            })
            .catch(err => {
                console.error('Error fetching tracking actions:', err);
                setActions([]);
            })
            .finally(() => setLoading(false));
    }, [show, patientExamId, patientResultId]);

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Patient Tracking Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center py-3">
                        <i className="fas fa-spinner fa-spin mr-2" />
                        Loading...
                    </div>
                ) : actions.length === 0 ? (
                    <p className="text-muted text-center py-3">No tracking actions found for this result.</p>
                ) : (
                    <PatientTrackingActionsList actions={actions} showHeader={false} />
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-default" onClick={onHide}>Close</button>
            </Modal.Footer>
        </Modal>
    );
};

export default PatientTrackingResultModal;
